import { FilterCategory } from "../Enums";
import { ToolFilterOption } from "./ToolFilterOption";

export class ToolFilterCategory {
  id: string;
  key: string;
  title: string;
  options: ToolFilterOption[];
  public get isBoolean() {
    return this.id === FilterCategory.IsActive;
  }

  constructor(model: ToolFilterCategory) {
    Object.assign(this, model);
    return this;
  }
}
